'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigateToThreadList = navigateToThreadList;

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

var _clearCurrentChannel = require('../../actions/ConversationsActions/clearCurrentChannel');

var _updateView = require('../../current-view/actions/updateView');

var _views = require('../../current-view/constants/views');

function navigateToThreadList() {
  return function (dispatch) {
    dispatch((0, _clearCurrentChannel.clearCurrentChannel)());

    dispatch((0, _updateView.updateView)(_views.THREAD_LIST));

    dispatch((0, _trackInteraction.trackInteraction)('widget-interaction', {
      action: 'view thread list'
    }));
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/navigation/actions/navigateToThreadList.js
// module id = 509
// module chunks = 2 3